import {Box, Slide} from '@mui/material';
import {PageHeader} from "../Utils/PageHeader";
import React, {useEffect, useState} from "react";
import Carousel from "react-material-ui-carousel";
import {News} from "./components/News";
import {ListObjectsCommand, ListObjectsCommandOutput, S3Client,} from "@aws-sdk/client-s3"
import {fromCognitoIdentityPool} from "@aws-sdk/credential-providers";
import {easing} from "../Utils/Transitions";

export const NewsPage = () => {

    const [objects, setObjects] = useState<
        Required<ListObjectsCommandOutput>["Contents"]
    >([]);

    const [images, setImages] = useState<(string | undefined)[]>([])

    useEffect(() => {
        const client = new S3Client({
            region: "us-east-1",
            credentials: fromCognitoIdentityPool({
                clientConfig: {region: "us-east-1"},
                identityPoolId: "us-east-1:db9bca4d-17bb-418d-b47c-4c3ff9651628",
            }),
        });
        const command = new ListObjectsCommand({Bucket: "news.iteag.org"});
        client.send(command).then(
            ({Contents}) => {
                setObjects(Contents || [])
            }
        );
    }, []);

    useEffect(() => {
        setImages(objects.map(o => "https://s3.amazonaws.com/news.iteag.org/" + o.Key))
    }, [objects]);

    return (
        <Slide in={true} direction={"up"} timeout={500} easing={easing}>
            <Box sx={{mt: {sx: 4, md: 8}, mb: {sx: 0, md: 8}}}>
                <Box textAlign={"center"}>
                    <PageHeader text={"Nos Actualités"}/>
                </Box>

                {/*Desktop*/}
                <Box mb={4} sx={{mt: {sx: 4, md: 8}, display: {xs: "none", md: "block"}}}>
                    {
                        images.length > 1 && <Carousel animation={"slide"} interval={10000} changeOnFirstRender={true}>
                            {
                                images.map((o) =>
                                    <News key={o} image={o!}/>
                                )
                            }
                      </Carousel>
                    }

                    {
                        images.length === 1 && <News key={images[0]} image={images[0]!}/>
                    }

                </Box>

                {/*Mobile*/}
                <Box sx={{display: {xs: "flex", md: "none"}, flexDirection: "column"}}>
                    {
                        images.map((image) =>
                            <Box key={image} sx={{display: "flex", flexDirection: "column"}}
                                 borderBottom={"4px solid #355952"}>
                                <News image={image!}/>
                            </Box>
                        )
                    }
                </Box>
            </Box>
        </Slide>
    );
};